export default __webpack_public_path__ + "static/media/arrow_down.c95a4ae8.svg";